"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Functionality = require("../Functionality.style");
const LiveChatRender = _ref => {
  let {
    children,
    isAvailable,
    onChat
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    id: "liveagent_button_online"
  }), /*#__PURE__*/_react.default.createElement(_Functionality.NavItemButton, {
    disabled: !isAvailable,
    onClick: onChat
  }, children));
};
var _default = exports.default = LiveChatRender;